(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-eu"]) return;
  try {
    
  class EuStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('eu-sticky-header', EuStickyHeader);

  const initEuMegaMenus = () => {
    document.querySelectorAll('.eu-header-menu').forEach((details) => {
      if (details.dataset.euMegaReady === 'true') return;
      details.dataset.euMegaReady = 'true';

      const media = window.matchMedia('(min-width: 990px)');
      const panel = details.querySelector('.eu-mega-menu');
      let closeTimer = null;

      const cancelClose = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      const openMenu = () => {
        if (!media.matches) return;

        cancelClose();

        document.querySelectorAll('.eu-header-menu[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });

        details.open = true;
      };

      const scheduleClose = () => {
        if (!media.matches) return;

        cancelClose();
        closeTimer = window.setTimeout(() => {
          details.open = false;
          closeTimer = null;
        }, 420);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);

      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', scheduleClose);
      }

      details.addEventListener('focusin', () => {
        if (media.matches) {
          cancelClose();
          details.open = true;
        }
      });

      details.addEventListener('focusout', (event) => {
        if (media.matches && !details.contains(event.relatedTarget)) {
          scheduleClose();
        }
      });

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          cancelClose();
          details.open = false;
          details.querySelector('summary')?.focus();
        }
      });
    });
  };

  initEuMegaMenus();
  document.addEventListener('shopify:section:load', initEuMegaMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-retail"]) return;
  try {
    

  class RetailStickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = this.closest('.section-header');

      this.headerIsAlwaysSticky =

        this.getAttribute('data-sticky-type') === 'always' ||

        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};



      this.setHeaderHeight();



      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));



      if (this.headerIsAlwaysSticky) {

        this.header.classList.add('shopify-section-header-sticky');

      }



      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

    }



    setHeaderHeight() {

      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

    }



    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        this.header.classList.remove('scrolled-past-header');

        requestAnimationFrame(this.reset.bind(this));

      }



      this.currentScrollTop = scrollTop;

    }



    hide() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }



    reveal() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());

    }



    closeSearchModal() {

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      this.searchModal.close(false);

    }

  }



  customElements.define('retail-sticky-header', RetailStickyHeader);

  const initRetailMegaMenus = () => {
    document.querySelectorAll('.retail-header-menu').forEach((details) => {
      if (details.dataset.retailMegaReady === 'true') return;
      details.dataset.retailMegaReady = 'true';

      const media = window.matchMedia('(min-width: 990px)');
      const panel = details.querySelector('.retail-mega-menu');
      let closeTimer = null;

      const cancelClose = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      const openMenu = () => {
        if (!media.matches) return;
        cancelClose();

        document.querySelectorAll('.retail-header-menu[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });

        details.open = true;
      };

      const scheduleClose = () => {
        if (!media.matches) return;
        cancelClose();

        closeTimer = window.setTimeout(() => {
          details.open = false;
          closeTimer = null;
        }, 420);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);

      if (panel) {
        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', scheduleClose);
      }

      details.addEventListener('focusin', () => {
        if (media.matches) {
          cancelClose();
          details.open = true;
        }
      });

      details.addEventListener('focusout', (event) => {
        if (media.matches && !details.contains(event.relatedTarget)) {
          scheduleClose();
        }
      });

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          cancelClose();
          details.open = false;
          details.querySelector('summary')?.focus();
        }
      });
    });
  };

  initRetailMegaMenus();
  document.addEventListener('shopify:section:load', initRetailMegaMenus);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
